<template>
 <div id="account" >
   <section class="special_services secpadd">
     <div class="container">
       <div class="row quote1top">
         <div class="col-md-8">
           <div class="fh-section-title clearfix  text-left version-dark paddbtm40">
             <h2>{{ $store.getters['heading/getPortalHeadings'].title }}</h2>
           </div>
         </div>
       </div>
     </div>
   </section>
 </div>
</template>

<script>
export default {
name: "Index"
}
</script>

<style scoped>

</style>